import {
  string as yupString,
} from 'yup';

import SelectFormik from '../../shared/forms/select/sdkSelectFormik.component';
import { required, nullable, uniqueWith, oneOfExistingTypeAndActivityCombination } from '../../shared/forms/validators';
import { hideField } from '../../shared/forms/constants';

import { countryTaxTypes } from '../../shared/constants';
import {
  CountryTaxTypes,
  GAAPs,
  G2Ss,
  Lines,
  Directions,
} from './constants';

const hideG2S = ({ formik }) =>
  formik.values.countryTaxType !== countryTaxTypes.XX1;

const schema = [
  {
    name: 'countryTaxType',
    component: SelectFormik,
    meta: { label: 'Country Tax Type', options: CountryTaxTypes },
    options: { disabledWhenEditing: true, yupType: yupString(), validationRules: [required, uniqueWith(['type', 'activity', 'slAccount'], 'Combination of Period, Country tax type, Activity and SL account fields already exists')] },
    additionalProps: { required: true },
  },
  {
    name: 'type',
    component: SelectFormik,
    meta: { label: 'Type', optionsKey: 'typeOptions' },
    options: {
      disabledWhenEditing: true,
      yupType: yupString(),
      validationRules: [required, oneOfExistingTypeAndActivityCombination, uniqueWith(['countryTaxType', 'activity', 'slAccount'], 'Combination of Period, Country tax type, Activity and SL account fields already exists')],
    },
    additionalProps: { required: true },
  },
  {
    name: 'activity',
    component: SelectFormik,
    meta: { label: 'Activity', optionsKey: 'activityOptions' },
    options: {
      disabledWhenEditing: true,
      yupType: yupString(),
      validationRules: [required, oneOfExistingTypeAndActivityCombination, uniqueWith(['countryTaxType', 'type', 'slAccount'], 'Combination of Period, Country tax type, Activity and SL account fields already exists')],
    },
    additionalProps: { required: true },
  },
  {
    name: 'slAccount',
    component: SelectFormik,
    meta: { label: 'SL Account', optionsKey: 'slAccountOptions' },
    options: { disabledWhenEditing: true, yupType: yupString(), validationRules: [required, uniqueWith(['countryTaxType', 'type', 'activity'], 'Combination of Period, Country tax type, Activity and SL account fields already exists')] },
    additionalProps: { required: true },
  },
  {
    name: 'gaap',
    component: SelectFormik,
    meta: { label: 'GAAP', options: GAAPs },
    options: { yupType: yupString(), validationRules: [nullable] },
    additionalProps: { clearable: true },
  },
  {
    name: 'g2s',
    component: SelectFormik,
    meta: { label: 'G2S', options: G2Ss },
    options: { yupType: yupString(), validationRules: [nullable] },
    additionalProps: { clearable: true },
    conditions: [
      {
        when: hideG2S,
        then: hideField,
      },
    ],
  },
  {
    name: 'line',
    component: SelectFormik,
    meta: { label: 'Line', options: Lines },
    options: { yupType: yupString(), validationRules: [nullable] },
    additionalProps: { clearable: true },
  },
  {
    name: 'direction',
    component: SelectFormik,
    meta: { label: 'Direction', options: Directions },
    options: { yupType: yupString(), validationRules: [nullable] },
    additionalProps: { clearable: true },
  },
  {
    name: 'glAccountCurrent',
    component: SelectFormik,
    meta: { label: 'GL Account Current', optionsKey: 'glAccountOptions' },
    options: { yupType: yupString(), validationRules: [nullable] },
    additionalProps: { clearable: true, virtualized: true },
  },
  {
    name: 'glAccountPrior',
    component: SelectFormik,
    meta: { label: 'GL Account Prior', optionsKey: 'glAccountOptions' },
    options: { yupType: yupString(), validationRules: [nullable] },
    additionalProps: { clearable: true, virtualized: true },
  },
  {
    name: 'glAccount2ndPrior',
    component: SelectFormik,
    meta: { label: 'GL Account 2nd Prior', optionsKey: 'glAccountOptions' },
    options: { yupType: yupString(), validationRules: [nullable] },
    additionalProps: { clearable: true, virtualized: true },
  },
];

export default schema;
